/** Skor kalıcılığı — rekor localStorage'da tutulur. */

const HI_SCORE_KEY = "snake3310.hiscore";

export function loadHiScore(): number {
  const parsed = parseInt(localStorage.getItem(HI_SCORE_KEY) ?? "0", 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

export function saveHiScore(score: number): void {
  localStorage.setItem(HI_SCORE_KEY, String(score));
}
